/**
 * Returns the customer data
 */
export function getCustomer(
  data?: Content.Components['SimpleCustomerModuleDto'],
): Content.Properties.Customer | undefined {
  if (!data) return undefined;

  if (!data.customer) return undefined;

  return data.customer;
}
